type MuiTypographyType = { [k: string]: any };

const MuiTypography: MuiTypographyType = {
  root: {
    wordWrap: "break-word",
  },
};

export default MuiTypography;
